var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"login-screen-page",attrs:{"name":"reg-screen-page"}},[_c('Navbar',{attrs:{"title":_vm.$t('profile')}}),_vm._v(" "),_c('Form',{attrs:{"update":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }